import { tokens } from '@opendoor/tokens-studio/dist/bricks-next/tokens/Components';

import { Box } from '../../Box';
import type { BoxProps } from '../../Box';

const { formLayout: formLayoutTokens } = tokens;

/**
 * Container for form inputs. Applies standard spacing between questions.
 */
export const QuestionContainer = ({ children }: Pick<BoxProps, 'children'>) => {
  return (
    <Box
      gap={formLayoutTokens.padding.questions.betweenContent.xsmallviewport}
      $group-formLayout-largerThanXS={{
        gap: formLayoutTokens.padding.questions.betweenContent.smallviewport,
      }}
      $group-formLayout-largerThanSM={{
        gap: formLayoutTokens.padding.questions.betweenContent.mediumviewport,

        flexBasis: '50%',
        flexShrink: 1,
      }}
      $group-formLayout-largerThanMD={{
        gap: formLayoutTokens.padding.questions.betweenContent.largeviewport,
      }}
      $group-formLayout-largerThanLG={{
        gap: formLayoutTokens.padding.questions.betweenContent.xlargeviewport,
      }}
    >
      {children}
    </Box>
  );
};
